module.exports = __webpack_public_path__ + "img/NODATA.d910fba1.png";